import { useUpdateAtom } from 'jotai/utils';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import breadcrumbsAtom from "../data/atoms/breadcrumbs";


function useBreadcrumbs(item) {
    const location = useLocation();
    const setBreacrumbs = useUpdateAtom(breadcrumbsAtom);
    useEffect(
        () => {
            if (!item.to) item.to = location.pathname + location.search + location.hash;
            setBreacrumbs(item);
        },
        // eslint-disable-next-line
        [location]
    );
}

export default useBreadcrumbs;